import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_col = _resolveComponent("van-col");
  const _component_van_row = _resolveComponent("van-row");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_ListViewCpt = _resolveComponent("ListViewCpt");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, {
    class: "synthetical-commission-page"
  }, {
    default: _withCtx(() => [_createVNode(_component_ListViewCpt, {
      ref: "ListViewCpt",
      request: $data.listRequest,
      requestParameter: $data.searchForm
    }, {
      default: _withCtx(({
        item
      }) => [_createVNode(_component_van_cell, {
        title: item.policyHolderName + ' - ' + item.productName
      }, {
        label: _withCtx(() => [_createVNode(_component_van_row, {
          gutter: "20"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("订单号：" + _toDisplayString(item.orderNo), 1)]),
            _: 2
          }, 1024), _createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("下单时间: " + _toDisplayString(item.applicationDate), 1)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024), _createVNode(_component_van_row, {
          gutter: "20"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("下单人: " + _toDisplayString(item.memberName), 1)]),
            _: 2
          }, 1024), _createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("兼职代理人: " + _toDisplayString(item.partTimerName), 1)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024), _createVNode(_component_van_row, {
          gutter: "20"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("险种名称: " + _toDisplayString(item.riskName), 1)]),
            _: 2
          }, 1024), _createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("主附险: " + _toDisplayString(_ctx.formatSelectColumn($data.codeResItems, 'prFlag', {
              prFlag: item.prFlag
            })), 1)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024), _createVNode(_component_van_row, {
          gutter: "20"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("保单年度: " + _toDisplayString(item.policyYear), 1)]),
            _: 2
          }, 1024), _createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("订单状态: " + _toDisplayString(_ctx.formatSelectColumn($data.codeResItems, 'orderStatus', {
              orderStatus: item.orderStatus
            })), 1)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024), _createVNode(_component_van_row, {
          gutter: "20"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("保费: " + _toDisplayString(item.premium), 1)]),
            _: 2
          }, 1024), _createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("业务费率: " + _toDisplayString(item.commissionRate), 1)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024), _createVNode(_component_van_row, {
          gutter: "20"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("业务费: " + _toDisplayString(item.commission), 1)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["title"])]),
      _: 1
    }, 8, ["request", "requestParameter"])]),
    _: 1
  });
}